import { clowncar } from 'types';
import { consumer, payloadToJSON } from '@tock/coretypes';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

interface InitialState {
  requestInProgress?: boolean;
  isInitialized?: boolean;
  consumerPageConfigList?: clowncar.ConsumerPageConfig[];
  consumerPageConfig?: clowncar.ConsumerPageConfig | null;
  namedConfigurations: consumer.INamedConfiguration[];
  collectionDataConfigurations: consumer.ICollectionDataConfiguration[];
}

const initialState: InitialState = {
  isInitialized: false,
  consumerPageConfigList: [],
  consumerPageConfig: null,
  namedConfigurations: [],
  collectionDataConfigurations: [],
  requestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_GET_ALL_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_INSERT_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_PUT_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_REMOVE_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_GET_ALL_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_INSERT_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_PUT_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_REMOVE_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_DRAFT_GET_ALL_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_UPDATE_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_DRAFT_UPDATE_STARTING:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_INSERT_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_DRAFT_GET_ALL_DONE: {
      return {
        ...state,
        requestInProgress: false,
        consumerPageConfigList: payloadToJSON<clowncar.ConsumerPageConfig[]>(payload),
        isInitialized: true,
      };
    }
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_SELECT:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_UPDATE_DONE:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_DRAFT_UPDATE_DONE:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_DRAFT_GET_DONE:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_GET_BY_DRAFT_DONE:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_GET_DONE: {
      return {
        ...state,
        consumerPageConfig: payloadToJSON<clowncar.ConsumerPageConfig>(payload),
      };
    }
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_GET_ALL_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_INSERT_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_PUT_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_REMOVE_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_GET_ALL_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_INSERT_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_PUT_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_REMOVE_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_DRAFT_GET_ALL_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_UPDATE_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_DRAFT_UPDATE_FAILED:
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_INSERT_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case ClowncarAppConstants.CONSUMER_PAGE_CONFIG_CLEAR: {
      return {
        ...state,
        consumerPageConfig: initialState.consumerPageConfig,
      };
    }
    case ClowncarAppConstants.CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_GET_ALL_DONE: {
      const collectionDataConfigurations =
        payloadToJSON<consumer.ICollectionDataConfiguration[]>(payload);

      return {
        ...state,
        collectionDataConfigurations,
        requestInProgress: false,
      };
    }
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_GET_ALL_DONE: {
      const namedConfigurations = payloadToJSON<consumer.INamedConfiguration[]>(payload);

      return {
        ...state,
        namedConfigurations,
        requestInProgress: false,
      };
    }
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_PUT_DONE:
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_INSERT_DONE: {
      const newConfiguration = payloadToJSON<consumer.INamedConfiguration>(payload);
      return {
        ...state,
        namedConfigurations: [...state.namedConfigurations, newConfiguration],
        requestInProgress: false,
      };
    }
    case ClowncarAppConstants.CONSUMER_PAGE_NAMED_CONFIGS_REMOVE_DONE: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    default:
      return state;
  }
}
